import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-colorize',
    templateUrl: './colorize.component.html',
    styleUrls: ['./colorize.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColorizeComponent implements OnInit {
  r = 0.01;
  b = 1;
  g = 1;
  a = 1;
  mixBlendMode = new UntypedFormControl('color');
  showMenu$ = new BehaviorSubject(true);
  sampleUrl$ = new BehaviorSubject(null);
  showSample = false;
  baseUrl$ = new BehaviorSubject<SafeUrl>('assets/test/1.jpg');
  maskPng$ = new BehaviorSubject<SafeUrl>('assets/test/1.png');

  get matrix() {
    return `0 0 0 0 ${this.r} 
               0 0 0 0 ${this.g} 
               0 0 0 0 ${this.b} 
               0 0 0 1 0`;
  }

  private _color;

  get color() {
    return this._color;
  }

  set color(color: string) {
    console.log(color);
    if (color.substr(0, 4) === 'rgba') {
      const colors = color
        .substring(4)
        .substring(1, color.substring(4).length - 1)
        .split(',');
      console.log(colors);
      this.r = this.parseValue(parseInt(colors[0]));
      this.g = this.parseValue(parseInt(colors[1]));
      this.b = this.parseValue(parseInt(colors[2]));
      this.a = Number(colors[3]);
      console.log(colors[3], this.a);
    } else {
      const colors = color
        .substring(3)
        .substring(1, color.substring(3).length - 1)
        .split(',');
      console.log(colors);
      this.r = this.parseValue(parseInt(colors[0]));
      this.g = this.parseValue(parseInt(colors[1]));
      this.b = this.parseValue(parseInt(colors[2]));
    }
    document.body
      .querySelector('feColorMatrix')
      .setAttribute('values', this.matrix);
    this._color = color;
  }

  set opacity(opacity) {}

  constructor(
    private cd: ChangeDetectorRef,
    private domSanitizer: DomSanitizer
  ) {}

  parseValue(val) {
    return Math.round((val / 255) * 100) / 100;
  }

  ngOnInit(): void {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'h') {
        this.showMenu$.next(!this.showMenu$.value);
      }
    });
  }

  loadSample(e: Event) {
    const file = (e.target as HTMLInputElement).files[0];

    this.sampleUrl$.next(
      this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file))
    );
  }

  loadMainImage(e: Event) {
    const file = (e.target as HTMLInputElement).files[0];

    this.baseUrl$.next(
      this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file))
    );
  }

  loadMaskImage(e: Event) {
    const file = (e.target as HTMLInputElement).files[0];

    this.maskPng$.next(
      this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file))
    );
  }
}
